import { ReactNode, useRef, useState } from "react";
import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { Box } from "@mui/material";
import { UIErrorDisplay } from "./UIErrorDisplay";
import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export interface UIValidationTooltipProps {
    children?: ReactNode;
    validationIssues?: ValidationIssue[];
}

export function UIValidationTooltip(props: UIValidationTooltipProps) {
    let ref = useRef<HTMLDivElement>();
    const [hovered, setHovered] = useState<boolean>(false);

    return (
        <Box
            ref={ref}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            width={"100%"}
        >
            {props.children}
            {props.validationIssues !== undefined && props.validationIssues.length > 1 && hovered && (
                <StyledTooltip onMouseLeave={() => setHovered(false)}>
                    <Box minWidth={"150px"}>
                        <UIErrorDisplay validationBreaks={props.validationIssues} />
                    </Box>
                </StyledTooltip>
            )}
        </Box>
    );
}

export const StyledTooltip = styled.div`
    && {
        position: absolute;
        border-radius: 4px;
        padding: 6px;
        background: ${UIStyleConstants.WHITE_COLOR};
        font-size: 14px;
        font-family: sans-serif;
        line-height: 1;
        z-index: 100;
        white-space: nowrap;
    }
`;
